@let localUserQualification = userQualification() || 0;
@let localQualification = qualification();
@let localInfoCalification = infoCalification();

<div class="card rounded-3 shadow border-gray">
  <div class="card-body d-flex flex-column align-items-center">
    <h6 class="card-title text-center fw-semibold">
      {{ 'geomarker.title_card_rating' | translate }}
    </h6>
    <app-rating
      class="w-auto"
      [showRatingNumber]="false"
      [buttonTemplate]="buttonCalification"
      [qualification]="localUserQualification"
      [disabled]="hasQualification()"
      [marginAuto]="true"
      size="32px"
      (qualificationChange)="setQualification($event)"
    />

    <div class="d-flex flex-column align-items-center gap-2 w-100 mt-4">
      <span class="fs-3 fw-bold">{{ localQualification }}</span>
      <app-rating [showRatingNumber]="false" [qualification]="+localQualification" size="22px" />
      <div class="d-flex align-items-center justify-content-center gap-4">
        <div class="d-flex align-items-center gap-1">
          <span>({{ localQualification }})</span>
          <span>{{ localInfoCalification?.total_ratings }} {{ 'valoraciones' | translate }}</span>
        </div>
        <div class="d-flex align-items-center gap-1">
          <i class="inm-icon-comment"></i>
          <span>{{ valuations() }} {{ '$valuations_text_plural' | translate }}</span>
        </div>
      </div>
    </div>

    <div class="d-flex flex-column w-100 mt-4 gap-2">
      @for (q of qualificationArray(); track q) {
        <div class="d-flex align-items-center">
          <i class="inm-icon-star yellow-text me-1" style="font-size: 16px"></i>
          <span>{{ q.qualification }}</span>
          <meter
            class="w-100 ms-2 me-3"
            [value]="q.numQualifications"
            [max]="localInfoCalification?.total_ratings"
          ></meter>
          <span class="text-end" style="min-width: 38px">{{ q.percentage }}%</span>
        </div>
      }
    </div>
  </div>
</div>

<ng-template #buttonCalification>
  <button (click)="editCalification()" class="dark-blue fw-normal px-4 mt-2 rounded-4">
    {{ (hasQualification() ? 'edit' : 'calificar') | translate }}
  </button>
</ng-template>
